/* Progressive, local article discovery and accessible article contents. */
(() => {
  'use strict';
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  function init(root) {
    root.querySelectorAll('[data-gxlh-library]').forEach(lib => {
      if (lib.dataset.ready) return;
      lib.dataset.ready = '1';
      const field = lib.querySelector('input[type="search"]');
      const controls = lib.querySelector('[data-gxlh-search]');
      const notice = lib.querySelector('[data-gxlh-empty]');
      const status = lib.querySelector('[data-gxlh-count]');
      const reset = lib.querySelector('[data-gxlh-reset]');
      const cards = [...lib.querySelectorAll('[data-gxlh-item]')];
      const groups = [...lib.querySelectorAll('[data-gxlh-group]')];
      const links = [...lib.querySelectorAll('[data-gxlh-topic-link]')];
      if (!field || !cards.length || !groups.length) return;
      const terms = cards.map(card => normalize(card.textContent));
      const resolveHash = hash => groups.find(group => '#' + group.id === hash.replace('#gxlh-topic-', '#gxlh-library-'));
      let selected = resolveHash(location.hash) || groups[0];
      const filter = () => {
        const words = normalize(field.value).split(/\s+/).filter(Boolean);
        const searching = words.length > 0;
        let shown = 0;
        cards.forEach((card, i) => {
          card.hidden = searching && !words.every(word => terms[i].includes(word));
          if (!card.hidden) shown++;
        });
        groups.forEach(group => {
          group.hidden = searching ? ![...group.querySelectorAll('[data-gxlh-item]')].some(card => !card.hidden) : group !== selected;
        });
        links.forEach(link => {
          if (!searching && link.hash === '#' + selected.id) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        notice.hidden = !searching || shown > 0;
        reset.hidden = !field.value;
        status.textContent = searching ? shown + ' ' + (shown === 1 ? status.dataset.singular : status.dataset.label) : '';
        lib.classList.toggle('gxlh-library--searching', searching);
      };
      const showTopic = (group, moveFocus) => {
        selected = group;
        field.value = '';
        filter();
        if (moveFocus) {
          group.querySelector('h3').focus({ preventScroll: true });
          group.scrollIntoView({ block: 'start', behavior: 'auto' });
        }
      };
      controls.hidden = false;
      field.addEventListener('input', filter);
      field.addEventListener('search', filter);
      reset.addEventListener('click', () => { field.value = ''; filter(); field.focus(); });
      root.querySelectorAll('a[href^="#gxlh-library-"],a[href^="#gxlh-topic-"]').forEach(link => {
        link.addEventListener('click', event => {
          const group = resolveHash(link.hash);
          if (!group) return;
          event.preventDefault();
          if (location.hash !== '#' + group.id) history.pushState(null, '', '#' + group.id);
          showTopic(group, true);
        });
      });
      window.addEventListener('hashchange', () => {
        const group = resolveHash(location.hash);
        if (group) showTopic(group, true);
        else if (!location.hash || location.hash === '#gxlh-library' || location.hash === '#gxlh-topics') showTopic(groups[0], false);
      });
      filter();
      if (resolveHash(location.hash)) requestAnimationFrame(() => selected.scrollIntoView({ block: 'start' }));
    });
    root.querySelectorAll('[data-gxlh-reader]').forEach(reader => {
      if (reader.dataset.ready) return;
      reader.dataset.ready = '1';
      const list = reader.querySelector('[data-gxlh-toc-list]');
      const toc = reader.querySelector('[data-gxlh-toc]');
      const body = reader.querySelector('[data-gxlh-body]');
      if (!list || !toc || !body) return;
      body.querySelectorAll('h2').forEach((heading, i) => {
        if (heading.closest('.gxlh-support,.gxlh-premium')) return;
        if (!heading.id) heading.id = 'gxlh-section-' + i;
        const li = document.createElement('li'), link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        li.appendChild(link);
        list.appendChild(li);
      });
      if (list.children.length) toc.hidden = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
